export enum PopoverSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  FullWidth = 'full-width',
}
